import { Icon } from '../Icon/Icon';

import './SubscriptionTypesList.scss';

type SubscriptionType = {
    iconId: number;
    name: string;
};

interface SubscriptionTypesListProps {
    items: SubscriptionType[];
}

export const SubscriptionTypesList = (props: SubscriptionTypesListProps) => {
    return (
        <div className="subscription-types-list">
            {props.items.map((item) => (
                <div className="subscription-types-list__item" key={item.iconId}>
                    <span className="subscription-types-list__icon">
                        <Icon symbol={item.iconId} />
                    </span>
                    <span>{item.name}</span>
                </div>
            ))}
        </div>
    );
};
